import { Component, OnInit } from '@angular/core';
import {IndividuService} from '@Common/core/services';
import {rolesBdc} from '../../common/enum/roles-bdc';

@Component({
  selector: 'p8-bdc-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss']
})
export class AccueilComponent implements OnInit {
  roles: string[] = [];
  notes = false;

  constructor(private individuSvc: IndividuService) {
  }

  ngOnInit() {
    this.individuSvc.individu$.subscribe(_individu => {

      if (this.individuSvc.hasRole(_individu, rolesBdc.admin)) {
        this.roles.push('Administrateur');
        this.notes = true;
      }

      if (this.individuSvc.hasRole(_individu, rolesBdc.supergestionnaire)) {
        this.roles.push('Super gestionnaire');
        this.notes = true;
      }

      if (this.individuSvc.hasRole(_individu, rolesBdc.gestionnaire)) {
        this.roles.push('Gestionnaire');
      }
    });
  }
}
